import React from 'react';
import { Divider } from 'antd';
import type { DividerProps } from 'antd';

export type AppDividerProps = DividerProps;

const AppDivider: React.FC<AppDividerProps> = props => {
  return <Divider {...props} />;
};

export default AppDivider;
